import '../../../Modals/XpektorBootstrapModal.scss';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import UserGroupService from '../../../../../Services/UserGroupService';
import UserService from '../../../../../Services/UserService';
import {
  XpektorForm,
  FormInput,
  FormButton,
} from '../../../../../Components/XpektorForms/XpektorForms';

/* eslint-disable react/prop-types */
export default function CreateUserGroupModal({ onGroupCreated, handleClose }) {
  const [groupName, setGroupName] = useState('');
  const [errorText, setErrorText] = useState('');
  const [creating, setCreating] = useState(false);
  const createGroup = async (e) => {
    e.preventDefault();
    if (errorText.length > 0) return;

    if (groupName.length === 0) setErrorText('Fältet kan inte vara tomt');

    setCreating(true);
    const user = UserService.getCurrentUser();

    await UserGroupService.createUserGroup(user.customerId, groupName)
      .then(() => {
        onGroupCreated();
        handleClose();
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setErrorText('Det finns redan en grupp med det namnet');
        }
      })
      .finally(() => {
        setCreating(false);
      });
  };
  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      centered
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Skapa användargrupp</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <XpektorForm onSubmit={createGroup}>
          <FormInput
            label="Gruppens namn"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            infoText={errorText}
          />
          <FormButton text="Skapa användargrupp" disabled={creating} />
        </XpektorForm>
      </Modal.Body>
    </Modal>
  );
}
